class LearnMore {
  constructor(
    id,
    hashedInfoChunks,
    informationChunks,
    title,
    titleHash,
    subrightID
  ) {
    this.id = id;
    this.hashedInfoChunks = hashedInfoChunks;
    this.informationChunks = informationChunks;
    this.title = title;
    this.titleHash = titleHash;
    this.subrightID = subrightID;
  }
}

export default LearnMore;
